/* eslint-disable */
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import MainCard from 'components/MainCard';
import { Controller, useForm } from 'react-hook-form';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { getEquipmentCategoriesById, getEquipmentCategoriesByQuery, getMasterEquipmentPartsById, getMasterEquipmentPartsByQuery } from 'components/axios/equipmentCategoryAxios';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import CustomFormSelect from 'components/select/CustomFormSelect';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentsById, getEquipmentsByQuery } from 'components/axios/equipmentAxios';
import CustomDateTimePicker from 'components/date_picker/CustomDateTimePicker';
import axios from 'axios';
import moment from 'moment';
import { useEnumApi } from 'contexts/EnumApiContext';
import { useRef } from 'react';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import CustomFormAutocompleteSelect from 'components/select/CustomFormAutocompleteSelect';
import { orderString } from 'data/data';
import EquipmentPartListLayer from './EquipmentPartListLayer';
import CustomDatePicker from 'components/date_picker/CustomDatePicker';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import { customFileAxios } from 'components/axios/customAxios';

const MaintenanceByNoAlertRequestLayer = ({
    // subwayCode : parentSubwayCode, workingPartId : parentWorkingPartId, stationId : parentStationId,
    equipmentCategoryLevel1Id : parentEquipmentCategoryLevel1Id ,equipmentCategoryLevel2Id : parentEquipmentCategoryLevel2Id ,equipmentCategoryLevel3Id : parentEquipmentCategoryLevel3Id
    , equipmentId : parentEquipmentId, setIsLoading:setParentIsLoading, type}) => {

    const { getEnumValueByEnumName, equipmentCategoryLevel1s } = useEnumApi();
    // const { name, subway, workingPart } = useSelector(state => state.user);
    const { name } = useSelector(state => state.user);
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const regexDateTime = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):(0[1-9]|[0-5][0-9])$/);
    const numberRegEx = /^[0-9]*$/;

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false)};
    const handleClose = () => setOpen(false);

    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
    const [equipments, setEquipments] = useState([]);
  
    const [equipment, setEquipment] = useState(null);

    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [equipmentId, setEquipmentId] = useState('');
    const [equipmentNo, setEquipmentNo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [equipmentParam, setEquipmentParam] = useState({});

    const { control, register, handleSubmit, reset, setValue, watch, formState : {isDirty, errors } } = useForm({});

    // 상황보고 필드 값 감시
    const watchDate = watch("reportYmd");
    const watchReporter = watch("reportUser");
    
    useEffect(() => {
      // if (parentSubwayCode || subway) {
      //   setSubwayCode(parentSubwayCode || subway);
      // }
      if (parentEquipmentCategoryLevel1Id) {
        setEquipmentCategoryLevel1Id(parentEquipmentCategoryLevel1Id);
      }
    // },[parentSubwayCode, subway, parentEquipmentCategoryLevel1Id]);
    },[parentEquipmentCategoryLevel1Id]);
    
    useEffect(()=>{
      if (parentEquipmentId && open) {
        getEquipmentsByQuery({id:parentEquipmentId}).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipments;
            if (list && list.length > 0) {
              setEquipment({label:list[0].name , id:list[0].id});
              // setSubwayCode(list[0].station && list[0].station.workingPart && list[0].station.workingPart.subwayLine);
              // setValue('subwayCode', ((list[0].station && list[0].station.workingPart && list[0].station.workingPart.subwayLine) || null));
              // setWorkingPartId(list[0].station && list[0].station.workingPart && list[0].station.workingPart.id);
              // setValue('workingPartId', ((list[0].station && list[0].station.workingPart && list[0].station.workingPart.id) || null));
              // setStationId(list[0].station && list[0].station.id);
              // setValue('stationId', ((list[0].station && list[0].station.id) || null));
              setEquipmentCategoryLevel1Id(list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.parent && list[0].equipmentCtgr.parent.parent.id);
              setValue('equipmentCategoryLevel1Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.parent && list[0].equipmentCtgr.parent.parent.id) || null));
              setEquipmentCategoryLevel2Id(list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.id);
              setValue('equipmentCategoryLevel2Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.id) || null));
              setEquipmentCategoryLevel3Id(list[0].equipmentCtgr && list[0].equipmentCtgr.id);
              setValue('equipmentCategoryLevel3Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.id) || null));
              setEquipmentId((list[0].id || null));
              setValue('equipmentId', (list[0].id || null));
              setEquipmentNo((list[0].equipmentNo || null));
              setValue('equipmentNo', (list[0].equipmentNo || null));
              return list[0];
            } else {
              setEquipment(null);
              return {};
            }
          }
        }).then((res)=>{
        })
      }
    },[parentEquipmentId, open]);

    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //   if ((subwayCode || parentSubwayCode || subway) && open) {
    //       const param = {"subwayLine" : (subwayCode || parentSubwayCode || subway), size:50}
    //       getWorkingPartsByQuery(param).then((data)=>{
    //           if (data && data._embedded) {
    //               let workingParts = data._embedded.workingParts;
    //               setWorkingParts(workingParts);
    //               const wId = (workingPartId || parentWorkingPartId || workingPart) || (equipment?.station && equipment.station?.workingPart && equipment.station?.workingPart?.id) || '';
    //               let belongDatas = null;
    //               if (wId) {
    //                 setWorkingPartId(wId);
    //                 belongDatas = data._embedded.workingParts.filter(item=> item.id == wId);
    //               }                 
    //               if (wId && belongDatas && belongDatas.length > 0) {
    //                 setValue("workingPartId", wId);
    //               } else if (equipment && equipment?.station && equipment?.station?.workingPart) {
    //                 setValue("workingPartId", (equipment?.station?.workingPart?.id || ''));
    //               } else {
    //                 setWorkingPartId('');
    //                 setValue("workingPartId", '');
    //               }
    //           } else {
    //               setWorkingPartId('');
    //               setValue("workingPartId", '');
    //               setWorkingParts([]);
    //           }
    //           setStations([]);
    //           setEquipments([]);
    //       });
    //   }
    // },[subwayCode, parentSubwayCode, subway, open]);
    
    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //   if ((workingPartId || parentWorkingPartId || workingPart) && open) {
    //       const param = {"workingPart.id" : (workingPartId || parentWorkingPartId || workingPart), sort:"code,asc", size:50};
    //       getStationsByQuery(param).then((data)=>{
    //           if (data && data._embedded) {
    //               setStations(data._embedded.stations);
    //               const sId = (stationId || parentStationId) || (equipment?.station && equipment?.station?.id) || '';
    //               let belongDatas = null;
    //               if (sId) {
    //                 setStationId(sId);
    //                 belongDatas = data._embedded.stations.filter(item=> item.id == sId);
    //               }                 
    //               if (sId && belongDatas && belongDatas.length > 0) {
    //                 setValue("stationId", sId);
    //               } else if (equipment && equipment.station) {
    //                 setValue("stationId", (equipment.station?.id || ''));
    //               } else {
    //                 setStationId('');
    //                 setValue("stationId", '');
    //               }
    //           } else {
    //               setStationId('');
    //               setValue("stationId", '');
    //               setStations([]);
    //           }
    //           setEquipments([]);
    //       });
    //   }
    // },[workingPartId, parentWorkingPartId, workingPart, open]);

    // 설비중분류 목록
    useEffect(()=>{
        if ((equipmentCategoryLevel1Id || parentEquipmentCategoryLevel1Id) && open) {
            const param = { "parent.id": (equipmentCategoryLevel1Id || parentEquipmentCategoryLevel1Id), depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    setEquipmentCategoryLevel2s(data._embedded.equipmentCategories);
                    const sId = ((equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id) || (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent && equipment.equipmentCtgr.parent.id) || '');
                    let belongDatas = null;
                    if (sId) {
                      setEquipmentCategoryLevel2Id(sId);
                      belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                    }                 
                    if (sId && belongDatas && belongDatas.length > 0) {
                      setValue("equipmentCategoryLevel2Id", sId);
                    } else if (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent) {
                      setValue("equipmentCategoryLevel2Id", (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent && equipment.equipmentCtgr.parent.id) || '');
                    } else {
                      setEquipmentCategoryLevel2Id('');
                      setValue("equipmentCategoryLevel2Id", '');
                    }
                } else {
                    setEquipmentCategoryLevel2Id('');
                    setValue("equipmentCategoryLevel2Id",'');
                    setEquipmentCategoryLevel2s([]);
                }
                setEquipmentCategoryLevel3s([]);
                setEquipments([]);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryLevel1Id, parentEquipmentCategoryLevel1Id, open]);

    // 설비분류 목록
    useEffect(()=>{
        if ((equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id) && open) {
            const param = { "parent.id": (equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id), depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    setEquipmentCategoryLevel3s(data._embedded.equipmentCategories);
                    const sId = ((equipmentCategoryLevel3Id || parentEquipmentCategoryLevel3Id) || (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.id) || '');
                    let belongDatas = null;
                    if (sId) {
                      belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                    }                 
                    if (sId && belongDatas && belongDatas.length > 0) {
                      setEquipmentCategoryLevel3Id(sId);
                      setValue("equipmentCategoryLevel3Id", sId);
                    } else if (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent) {
                      setEquipmentCategoryLevel3Id((equipment.equipmentCtgr && equipment.equipmentCtgr.id) || '');
                      setValue("equipmentCategoryLevel3Id", ((equipment.equipmentCtgr && equipment.equipmentCtgr.id) || ''));
                    } else {
                      setEquipmentCategoryLevel3Id('');
                      setValue("equipmentCategoryLevel3Id", '');
                    }
                } else {
                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id", '');
                    setEquipmentCategoryLevel3s([]);
                }
                setEquipments([]);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryLevel2Id, parentEquipmentCategoryLevel2Id, open]);

    // 설비 구성부, 구성부 위치 목록
    useEffect(()=>{
      if (!open) return
      if ((equipmentCategoryLevel3Id || parentEquipmentCategoryLevel3Id) && open) {
        Promise.all([
          getEquipmentCategoriesById((equipmentCategoryLevel3Id || parentEquipmentCategoryLevel3Id)).then((data) => {
            if (data && data.positions) {
              let positions = [];
              data.positions.map(function (item) {
                positions.push({ id: item, name: item });
              });
              orderString(positions,"id");
              setEquipmentCategoryPositions(positions);
            }
          }),
          getEquipmentCategoriesByQuery({ "parent.id": (equipmentCategoryLevel3Id || parentEquipmentCategoryLevel3Id), depth: 4, size: 100, sort: "name,asc" }).then((data) => {
            if (data && data._embedded) {
              setEquipmentCategoryComponents(data._embedded.equipmentCategories);
            }
          })
        ]).then(() => {
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryLevel3Id, parentEquipmentCategoryLevel3Id, open]);

    // 설비목록 
    useEffect(()=>{
      // if ((subwayCode && workingPartId && stationId && equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) && open) {
      if ((equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) && open) {
          const param = { 
            // "station.workingPart.subwayLine" : subwayCode,
            // "station.workingPart.id" : workingPartId,
            // "station.id" : stationId,
            "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
            "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
            "equipmentCtgr.id" : equipmentCategoryLevel3Id,
            size : 200
          };
          getEquipmentsByQuery(param).then((data) => {
              if (data && data._embedded) {
                  const list = data._embedded.equipments;
                  if (list) {
                    let equipmentSelects = [];
                    list.map(function(equipment, i) {
                        equipmentSelects.push({label:equipment.name , id:equipment.id})
                    })
                    setEquipments(equipmentSelects);
                  } else {
                    setEquipments([]);
                  }
              } else {
                setEquipments([]);
              }
          });
      } else {
      }
    // },[subwayCode, workingPartId, stationId, equipmentCategoryLevel1Id,equipmentCategoryLevel2Id,equipmentCategoryLevel3Id, open]);
    },[equipmentCategoryLevel1Id,equipmentCategoryLevel2Id,equipmentCategoryLevel3Id, open]);

    useEffect(()=>{
      if (equipmentId) {
        getEquipmentsById(equipmentId).then((data)=>{
          if (data) {
            setEquipmentNo(data.equipmentNo);
            setValue('equipmentNo', data.equipmentNo);
          }
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentId]);

    const nextID = useRef(1);
    const [inputFiles, setInputFiles] = useState([]);

    const nextPartID = useRef(1);
    const [inputParts, setInputParts] = useState([]);

    const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState(null);
    const [equipmentCategoryPositions, setEquipmentCategoryPositions] = useState(null);

    const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(null);
    const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
  
    useEffect(()=>{
      if (!open) return
      if (equipmentCategoryComponentId) {
        getMasterEquipmentPartsByQuery({ "equipmentCtgr.id": equipmentCategoryComponentId, size:100 }).then((data)=>{
          if (data && data._embedded) {
            setMasterEquipmentParts(data._embedded.masterEquipmentParts);
          }
        })
      }
    },[equipmentCategoryComponentId, open]);
  
    function addInputFile(file) {
      const input = {
          id: nextID.current,
          file: {},
          rFile: file,
      };
  
      setInputFiles([...inputFiles, input]);
      nextID.current += 1;
    }
  
    // 삭제
    function deleteInputFile(index) { 
        setInputFiles(inputFiles.filter(item => item.id !== index));
    }
  
    function handleInputFileChange(e, index) {
        if (index > inputFiles.length) return;
        
        
        let inputFilesCopy = [...inputFiles];
        inputFilesCopy[index].file = e.target.files[0];
        inputFilesCopy[index].rFile = null;
        setInputFiles(inputFilesCopy);
    }
  
    function addParts() {
      const input = {
        id: nextPartID.current,
        part : {
          id : 0,
          partId: 0,
          partLifeSpanTime : 0,
          count: 0,
        }
      };
      setInputParts([...inputParts, input]);
      nextPartID.current += 1;
    }
  
    // 삭제
    function deleteInputPart(index) { 
      setInputParts(inputParts.filter(item => item.id !== index));
    }
  
    function handleInputPartChange(e, index) {
        if (index > inputParts.length) return;
        const mPartId = e.target.value;
  
        Promise.all([
          getMasterEquipmentPartsById(mPartId).then((res)=>{
            let inputPartsCopy = [...inputParts];
            inputPartsCopy[index].part.partId = mPartId;
            inputPartsCopy[index].part.partLifeSpanTime = res.lifeSpanTime;
            setInputParts(inputPartsCopy);
          })
        ]);
    }
    
    function handleInputPartCountChange(e, index) {
        if (index > inputParts.length) return;
        
        let inputPartsCopy = [...inputParts];
        inputPartsCopy[index].part.count = e.target.value;
        setInputParts(inputPartsCopy);
    }

    const hasAnyValue = watchDate || watchReporter || (inputFiles && inputFiles.length > 0);
    // 등록
    const onSubmit = (data, e) => {
      setFileLoading(true);
      console.log(data);

      if (data.troubledAt != null && data.troubledAt != '' && !regexDateTime.test(data.troubledAt)) {
        alertMessage = t('message.common.alert.breakdown.maintenance.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.workingBgnAt != null && data.workingBgnAt != '' && !regexDateTime.test(data.workingBgnAt)) {
        alertMessage = t('message.common.alert.work.start.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.workingEndAt != null && data.workingEndAt != '' && !regexDateTime.test(data.workingEndAt)) {
        alertMessage = t('message.common.alert.work.end.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.troubledAt >= data.workingEndAt) {
        alertMessage = t('message.common.alert.work.end.datetime.not.equal.breakdown.datetime');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.cost != null && data.cost != '' && !numberRegEx.test(data.cost)) {
        alertMessage = t('message.common.alert.cost.only.number.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      
      let dto = {
        equipment : {id: data.equipmentId},
        equipmentCtgr : {id: data.componentId},
        cost : data.cost,
        mntSpType : data.mntSpType,
        importantYn : data.importantYn,
        position : data.position,
        recordType : data.recordType,
        remark : data.remark,
        status : data.status,
        troubleReason : data.troubleReason,
        troubledAt : (data.troubledAt?.$d != null ? moment(data.troubledAt.$d).format() : dayjs(data.troubledAt).format()),
        type : data.type,
        usedMethod : data.usedMethod,
        worker : data.worker,
        workingBgnAt : (data.workingBgnAt?.$d != null ? moment(data.workingBgnAt.$d).format() : dayjs(data.workingBgnAt).format()),
        workingEndAt : (data.workingEndAt?.$d != null ? moment(data.workingEndAt.$d).format() : dayjs(data.workingEndAt).format()),
      }
  
      let statusReport;
      if (data.reportUser || data.reportYmd) {
        statusReport = {
          "reportUser" : data.reportUser,
          "reportYmd" : data.reportYmd,
        }
        dto.statusReport = statusReport;
      }
  
      let formData = new FormData();
  
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }
  
      let equipmentParts = [];
      let isDuple = false;
      if(inputParts && inputParts.length > 0) {
        for (var m=0;m<inputParts.length;m++) {
          // console.log(inputParts[m])
            if (inputParts[m].part.partId) {
              let dupleChk = inputParts.filter(item => item.part.partId === inputParts[m].part.partId);
              //console.log(dupleChk);
              if (dupleChk.length > 1) {
                isDuple = true;
                break;
              } else {
                if (inputParts[m].part.id !== 0) {
                  equipmentParts.push({
                    id:inputParts[m].part.id, 
                    cnt : inputParts[m].part.count
                  })
                } else {
                  equipmentParts.push({
                    lifeSpanTime:inputParts[m].part.partLifeSpanTime, 
                    masterEquipmentPart:{
                      id:inputParts[m].part.partId
                    }, 
                    position : data.position,
                    cnt : inputParts[m].part.count
                  })
                }
              }
            }
        }
        dto.equipmentParts = equipmentParts;
      }
  
      if (isDuple) {
        alertMessage = t('message.common.alert.duplication.material.check.again');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.status === 'O3_C' && equipmentParts.length === 0) {
        alertMessage = t('message.common.alert.material.select.add');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.reportYmd || data.reportUser || (fileCnt) > 0) {
        if (data.reportYmd === null || data.reportYmd === undefined || data.reportYmd === '') {
          alertMessage = t('message.common.alert.status.report.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if (data.reportYmd != null && data.reportYmd != '' && !regexDate.test(data.reportYmd)) {
          alertMessage = t('message.common.alert.status.report.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if (data.reportUser === null || data.reportUser === undefined || data.reportUser === '') {
          alertMessage = t('message.common.alert.status.reporter.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if ((fileCnt) === 0) {
          alertMessage = t('message.common.alert.status.report.file.write');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
      }

      console.log(dto);
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.post(`/api/maintenanceTasks`, formData).then((res)=>{
                  console.log(res);
                  alertMessage = t('message.common.alert.write.done');
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                  setFileLoading(false);
                  setParentIsLoading(false);
                  reset();
                  nextID.current = 1;
                  setInputFiles([]);
                  nextPartID.current = 1;
                  setInputParts([]);
                  handleClose();
                  //navigate('../modify/'+res.data.id+window.location.search);
              }).catch((err)=>{
                  // console.log(err);
                  setFileLoading(false);
                  if (!err.response?.data?.message) {
                      alertMessage = err.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  } else if (err.response.data.message) {
                      alertMessage = err.response.data.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  }
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }

          // axios({
          //   method: "post",
          //   url: process.env.REACT_APP_API_URL+"/api/maintenanceTasks",
          //   data: formData,
          //   headers : {
          //       'Content-type' : 'multipart/form-data',
          //       accept : 'application/json,',
          //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //       'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //     console.log(res);
          //     alertMessage = t('message.common.alert.write.done');
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //     setFileLoading(false);
          //     setParentIsLoading(false);
          //     reset();
          //     nextID.current = 1;
          //     setInputFiles([]);
          //     nextPartID.current = 1;
          //     setInputParts([]);
          //     handleClose();
          // }).catch((err)=>{
          //     // console.log(err);
          //     setFileLoading(false);
          //     if (!err.response?.data?.message) {
          //         alertMessage = err.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     } else if (err.response.data.message) {
          //         alertMessage = err.response.data.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     }
          // });
        },
        onClose : () => {
            // console.log('close');
            setFileLoading(false);
        },
        message: t('message.common.alert.write.question'),
      });
    }

    return (
      <>
        {type && type === 'icon' &&
        <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="grey">
          <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/build.png`} alt='' /></span>
        </Button>
        }
        {(type === null || type === undefined || type === 'button') &&
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset",color:"#fff"}}>
          {t('message.common.title.maintenance')}
        </Button>
        }

        <Modal className="pop_box " open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard modal darkTitle content={false}>
            <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
              <div>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.title.maintenance')} color="success" />
              </div>

              <div>
                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
            </div>

            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
              <TableContainer>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell>
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="subwayCode"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                key={subwayCode}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.subwayline')}
                                register={register}
                                name={name}
                                defaultValue={subwayCode}
                                onChange={(e)=>{
                                    setSubwayCode(e.target.value);
                                    setWorkingPartId('');
                                    setValue('workingPartId', '');
                                    setStationId('');
                                    setValue('stationId', '');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={getEnumValueByEnumName("SubwayLine")}
                            />
                            )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell>
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="workingPartId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={workingPartId}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.workingPart')}
                                register={register}
                                name={name}
                                defaultValue={workingPartId}
                                onChange={(e)=>{
                                    setWorkingPartId(e.target.value);
                                    setStationId('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={workingParts}
                            />
                            )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell>            
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="stationId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={stationId}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.station')}
                                register={register}
                                name={name}
                                defaultValue={stationId}
                                onChange={(e)=>{
                                    setStationId(e.target.value);
                                }}
                                list={stations}
                            />
                            )}
                        />
                      </TableCell>
                    </TableRow> */}
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                      <TableCell>            
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel1Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel1Id}
                                style={{ minWidth: '90%', maxWidth: '110px'}}
                                label={t('message.common.subtitle.equipment.level1')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel1Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel1Id(e.target.value);
                                    setEquipmentCategoryLevel2Id('');
                                    setEquipmentCategoryLevel3Id('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={equipmentCategoryLevel1s}
                            />
                            )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                      <TableCell>            
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel2Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel2Id}
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.level2')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel2Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel2Id(e.target.value);
                                    setEquipmentCategoryLevel3Id('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={equipmentCategoryLevel2s}
                            />
                            )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                      <TableCell>            
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel3Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel3Id}
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.level3')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel3Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel3Id(e.target.value);
                                }}
                                list={equipmentCategoryLevel3s}
                            />
                            )}
                        />
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')} *</TableCell>
                      <TableCell colSpan="3">
                        <CustomFormAutocompleteSelect
                            freesolo
                            style={{width:"97%",marginLeft:"7px"}}
                            key={equipmentId}
                            labelName={t('message.common.subtitle.equipment.name')}
                            register={register}
                            name="equipmentId"  
                            autoSelect={true}
                            defaultValue={equipment || null}
                            requiredMessage={t('message.common.error.text.equipment.name.select')}
                            list={equipments}
                            onChange={(event, newValue, reason)=>{
                                if(reason !== 'clear'){
                                  setEquipmentId(newValue.id);
                                  setValue('equipmentId', newValue.id);
                                  setEquipment(newValue);
                                }
                            }}
                        />
                        {errors.equipmentId && <small role="alert"><br></br>{errors.equipmentId.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.number')} *</TableCell>
                      <TableCell>
                        <TextField style={{width:"90px"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                          {...register("equipmentNo", {
                              required : t('message.common.error.text.equipment.number.input')
                          })} 
                          disabled
                          key={equipmentNo}
                          defaultValue={equipmentNo}
                          sx={{ minWidth: '90%' }} />
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.occurrence.datetime')} *</TableCell>
                      <TableCell>
                        <Controller
                          control={control}
                          name="troubledAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.breakdown.maintenance.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.cause')} *</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        <TextField style={{width:"97%"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.troubleReason ? "true" : "false"}
                          {...register("troubleReason", {
                              required : t('message.common.error.text.breakdown.maintenance.cause.input')
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }} />
                        {errors.troubleReason && <small role="alert"><br></br>{errors.troubleReason.message}</small>}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.analysis.type')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.recordType ? "true" : "false"}
                          control={control}
                          name="recordType"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.analysis.type')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.analysis.type.select')}
                              defaultValue={''}
                              list={getEnumValueByEnumName("MaintenanceRecordType")}
                          />
                          )}
                        />
                        {errors.recordType && <small role="alert"><br></br>{errors.recordType.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.provider.type')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.mntSpType ? "true" : "false"}
                          control={control}
                          name="mntSpType"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.provider.type')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.provider.type.select')}
                              defaultValue={''}
                              list={getEnumValueByEnumName("MaintenanceProviderType")}
                          />
                          )}
                        />
                        {errors.mntSpType && <small role="alert"><br></br>{errors.mntSpType.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.main.management')}</TableCell>
                      <TableCell className="view_td">
                          <input type="checkbox" id="importantYn" {...register("importantYn", {
                          })}  />&nbsp;&nbsp;<label htmlFor="importantYn" style={{cursor:"pointer", color:"#000"}}></label>
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.work.start.datetime')} *</TableCell>
                      <TableCell>
                        <Controller
                          control={control}
                          name="workingBgnAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.work.start.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.work.end.datetime')} *</TableCell>
                      <TableCell>
                        <Controller
                          control={control}
                          name="workingEndAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.work.end.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.used.equipment')} *</TableCell>
                      <TableCell className="view_td">
                        <TextField style={{width:"90px"}} id="outlined-basic" 
                          {...register("usedMethod", {
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }} />
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.worker')} *</TableCell>
                      <TableCell className="view_td">
                        <TextField style={{width:"90%"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.worker ? "true" : "false"}
                          {...register("worker", {
                              required : t('message.common.error.text.worker.input')
                          })} 
                          defaultValue={name || ''}
                          sx={{ minWidth: '90%' }} />
                        {errors.worker && <small role="alert"><br></br>{errors.worker.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.work.status')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.status ? "true" : "false"}
                          control={control}
                          name="status"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.work.status')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.alert.work.status.select')}
                              defaultValue={''}
                              list={getEnumValueByEnumName("MaintenanceStatus").filter(item=>(item.code !== 'O1_R' && item.code !== 'O4_V'))}
                          />
                          )}
                        />
                        {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.actionType')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.type ? "true" : "false"}
                          control={control}
                          name="type"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.actionType')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.actionType.select')}
                              defaultValue={''}
                              list={getEnumValueByEnumName("MaintenanceType")}
                          />
                          )}
                        />
                        {errors.type && <small role="alert"><br></br>{errors.type.message}</small>}
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.work.detail')} *</TableCell>
                      <TableCell colSpan="5">
                        <TextField style={{width:"98%"}} id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                            {...register("remark", {
                                required : t('message.common.error.text.work.detail.input')
                            })} 
                            multiline
                            rows={4}
                            sx={{ minWidth: '90%' }} />
                        {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.component')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.componentId ? "true" : "false"}
                          control={control}
                          name="componentId"
                          render={({ field: {name} }) => (
                          <CustomFormSelect
                              style={{ minWidth: '90%', maxWidth: '110px' }}
                              label={t('message.common.subtitle.equipment.component')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.equipment.component.select')}
                              defaultValue={''}
                              onChange={(e)=>{
                                  setEquipmentCategoryComponentId(e.target.value);
                              }}
                              list={equipmentCategoryComponents}
                          />
                          )}
                        />
                        {errors.componentId && <small role="alert"><br></br>{errors.componentId.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.component.location')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.position ? "true" : "false"}
                          control={control}
                          name="position"
                          render={({ field: {name} }) => (
                          <CustomFormSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.component.location')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.component.location.select')}
                              defaultValue={''}
                              list={equipmentCategoryPositions}
                          />
                          )}
                        />
                        {errors.position && <small role="alert"><br></br>{errors.position.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.expense')}</TableCell>
                      <TableCell>
                        <TextField style={{width:"90px"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.cost ? "true" : "false"}
                          {...register("cost", {
                            pattern : {
                              value : numberRegEx,
                              message : t('message.common.error.text.number.only.input')
                            }
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }} />
                        {errors.cost && <small role="alert"><br></br>{errors.cost.message}</small>}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">
                      {t('message.common.subtitle.input.material')}
                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addParts}>+</AddCircleOutlineIcon>
                      </TableCell>
                      <TableCell colSpan={4}>
                        {inputParts && inputParts.map(function(item, index) {
                          return (
                        <div className="plus" key={index}>
                          <Controller
                            sx={{ m: 1, minWidth: 150 }}
                            control={control}
                            name="equipmentPartsId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={"equipmentPartsId_"+item.id}
                                style={{ minWidth: 150, marginLeft: '8px' }}
                                label={t('message.common.subtitle.input.material')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.material.select')}
                                defaultValue={item.part.partId || ''}
                                onChange={(e)=>{
                                  handleInputPartChange(e, index);
                                }}
                                list={(item.part && item.part.partId && item.part.id !== 0) ? masterEquipmentParts.filter(partItem => partItem.id===item.part.partId) : masterEquipmentParts}
                            />
                            )}
                          />
                          <div style={{marginLeft:"10px"}}>{t('message.common.subtitle.quantity')}</div>
                          <TextField 
                            key={"equipmentPartsCount_"+item.id}
                            id="outlined-basic" sx={{ m: 1, width: 50 }}
                            defaultValue={item.part.count || null}
                            onChange={(e)=>{handleInputPartCountChange(e, index)}} 
                          />
                          { inputParts[index] ? (
                              <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputPart(item.id)}>-</RemoveCircleOutlineIcon>
                          ) : (
                          ''
                          )}
                        </div>
                          )
                        })}
                      </TableCell>
                      <TableCell>
                        <EquipmentPartListLayer equipmentCtgrId={equipmentCategoryLevel1Id} />
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.status.report.date')}</TableCell>
                      <TableCell>
                        <div className="piker">
                          <Controller
                            control={control}
                            name="reportYmd"
                            defaultValue={null}
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDatePicker
                                field={field} ref={ref} name={name} value={value} register={register}
                                fieldState={fieldState}
                                hasAnyValue={hasAnyValue}
                                validateMessage={t('message.common.alert.status.report.date.input')}
                                />
                            )} />
                        </div>
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.status.reporter')}</TableCell>
                      <TableCell>
                        <TextField id="outlined-basic" 
                          {...register("reportUser", {
                              validate: (value) =>
                              !hasAnyValue || value ? true : t('message.common.alert.status.reporter.input'),
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }}
                          style={{marginLeft:"7px"}} />
                          {errors.reportUser && <small role="alert"><br></br>{errors.reportUser.message}</small>}
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">
                        {t('message.common.subtitle.status.report.file')}
                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                      </TableCell>
                      <TableCell colSpan="5" className='view_td_left'>
                        {inputFiles && inputFiles.map(function(item, index) {
                          return (
                          <div key={index} style={{display:"flex", alignItems:"center"}}>
                              <input
                                  type="file"
                                  value={''}
                                  style={{width:"unset", marginLeft: '8px' }}
                                  onChange={e => {
                                    handleInputFileChange(e, index);
                                  }}
                              />
                              {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.originFile)}
                              { inputFiles[index] ? (
                                  <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                              ) : (
                              ''
                              )}
                          </div>
                          )
                          })}
                          {hasAnyValue && inputFiles.length === 0 && (
                            <small role="alert"><br></br>{t('message.common.alert.status.report.file.write')}</small>
                          )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              </form>
            </CardContent>
            <Divider />
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                {t('message.common.btn.cancel')}
              </Button>
            </Stack>
          </MainCard>
        </Modal>
      </>
    )
}

export default MaintenanceByNoAlertRequestLayer;
